var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.content)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('v-card-text',[_vm._v("Нет данных")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }